import chatRepository from './repository';
import chatService from './service';
import createChatUseCase from './usecase';

const chatUseCase = createChatUseCase(chatRepository(chatService()))

export default chatUseCase;
